import { serverUrl, getheader } from "./CommonFunctions";

export function GetAllProduct() {
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksAPI/GetProductNames/")
      .then(res => res.json())
      .then(res => {
        //console.log(res);
        return dispatch({
          type: "FETCH_DATA_PRODUCT",
          data: res
        })
      }
      ).catch(err => console.error('[FETCH_DATA_PRODUCT]', err));
  };
}
export function GetAllModels(name) {
  //var token = localStorage.getItem('token');
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksAPI/GetProductModels/?ProductName=" + name, {
      headers: {
        // 'Token' :token ,
      },

    })
      .then(res => res.json())
      .then(res => {
        console.log(res);
        return dispatch({
          type: "FETCH_DATA_MODELS",
          data: res
        })
      }
      ).catch(err => console.error('[FETCH_DATA_MODELS]', err));
  };
}
export function searchProductForSelect(data) {
  let productCode = data.Code ?? "";
  productCode = productCode.replace(/\s/g, '');
  let productName = data.Name ?? "";
  productName = productName.replace(/\s/g, '');
  let productModel = data.Model ?? "";
  productModel = productModel.replace(/\s/g, '');
  let holder = data.HolderName ?? "";
  holder = holder.replace(/\s/g, '');
  return dispatch => {
    if (productCode === '' && productName === '' && productModel === '' && holder === '' && (data.GroupID ?? "") === "") {
      dispatch({
        type: "SEARCH_PRODUCT_SELECT",
        data: { Error: "هیچکدام از کادرهای جستجو پر نشده است" }
      })
      return;
    }
    dispatch({
      type: "SEARCH_PRODUCT_SELECT",
      data: "PENDING"
    })

    fetch(serverUrl + `api/ProductAPI/SearchProductForSelect`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        if (!res.ID) {
          if (res === "ProductNotFount") {
            res = {};
            res.Error = "کالایی با این مشخصات وجود ندارد";
          }
          if (res === "FillSearchFields") {
            res = {};
            res.Error = "کادرهای جستجو پر نشده است"
          }
          else if (res.Message === "Error") {
            res = {};
            res.Error = "اشکال در انجام عملیات";
            console.log("[SEARCH_PRODUCT_SELECT]", res);
          }
        }
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: res
        })
      }).catch(e => {
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: { Error: "اشکال در انجام عملیات" }
        });
        console.log("[SEARCH_PRODUCT_SELECT]", e)
      });
  }
}
export function setImagePopup(status) {
  return dispatch => {
    dispatch({
      type: "SET_IMAGE_POPUP",
      data: status
    });
  }
}
export function postRecieption(data, fn) {
  const _header = getheader()
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    data = JSON.stringify(data)
    fetch(serverUrl + "ReceptionTasksApi/SaveService/", {
      body: data,
      headers: _header,
      method: 'POST',
    })
      .then(res => res.json())
      .then(res => {

        dispatch({
          type: "LOADING",
          data: false
        })


        fn();


        return dispatch({
          type: "ADD_SERVICE",
          data: res
        })
      }
      ).catch(err => {
        console.error('[ADD_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}

export function getProductInfoBySerialOrCode(data) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrBarCode?serialAndBarCode=" + data,{
      headers:getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        dispatch({
          type: "FETCH_PRODUCT_BY_QRCODE",
          data: res
        })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}
export function setPopupStatus(status) {
  return dispatch => {
    return dispatch({
      type: "SET_POPUP_STATUS",
      data: status
    });
  }
}
export function resetProductQRCode() {
  return dispatch => {
    return dispatch({
      type: "FETCH_PRODUCT_BY_QRCODE",
      data: ""

    });
  }
}
export function getProductGroups4Select(name) {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCTGROUP_For_SELECT",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/GetProductGroups4Select?name=" + name ?? '', {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_PRODUCTGROUP_For_SELECT",
          data: res
        });
      }).catch(e => {
        console.log("[GET_PRODUCTGROUP_For_SELECT]", e);
      })
  }
}
export function searchStorage4Modal(name, take, onGetData) {
  onGetData("PENDING");
  fetch(serverUrl + `api/StorageAPI/SelectAllStorage?name=${name}&take=${take}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (res.message) {
        onGetData({ Error: res.Message })
        res = null;
      }
      onGetData(res);
    }).catch(e => {
      console.log("[SEARCH_STORAGE]", e);
      onGetData({ Error: "جستجو با مشکل مواجه شد" });
    }
    )
}
export function setDialog(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DIALOG",
      data: status
    });
  }
}


